module.exports = __webpack_public_path__ + "static/media/S20+_COSMICGREY.113f8574.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/samsung-galaxy/s20+/S20+_COSMICGREY.png
// module id = 2150
// module chunks = 0